import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ServiceCard from "./ServiceCard";
import { SectionHeading } from "./ServiceSections";
import data from "../data.json";

const OurServicesSection = () => {
  const { servicesList } = data;

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <SectionHeading
          title="Our Services"
          description="From power system studies and protective relay programming to automation and data analytics, we cover every stage of your power system."
        />
        {/* Flex wrap centers any partial last row; 3 per row keeps 6 cards as two even rows */}
        <div className="flex flex-wrap justify-center gap-6">
          {servicesList.map((service, index) => (
            <ServiceCard
              key={service.id}
              service={service}
              index={index}
              className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]"
            />
          ))}
        </div>
        <div className="text-center mt-10">
          <RouterLink
            to="/services"
            className="inline-flex items-center font-semibold text-custom-blue hover:text-custom-red transition-colors duration-300"
          >
            View all services
            <ArrowRight className="w-4 h-4 ml-2" />
          </RouterLink>
        </div>
      </div>
    </section>
  );
};

export default OurServicesSection;
